export default __webpack_public_path__ + "static/media/Broadsword of Okeanos.281b7e64.jpg";